// Whether the game screen uses the phone layout (docs/phone-plan.md):
// $prefs.layout 'phone' or 'desktop', or 'auto' for a touch screen no wider
// than a phone turned sideways.
import { derived, readable } from 'svelte/store';
import { prefs } from '../stores.js';

const PHONE_QUERY = '(pointer: coarse) and (max-width: 932px)';

const phoneScreen = readable(false, set => {
    if(typeof matchMedia != 'function') return;
    const mq = matchMedia(PHONE_QUERY);
    set(mq.matches);
    const change = e => set(e.matches);
    mq.addEventListener('change', change);
    return () => mq.removeEventListener('change', change);
});

export const phoneLayout = derived([prefs, phoneScreen], ([p, screen]) =>
    p.layout == 'phone' || (p.layout != 'desktop' && screen));

// use:hideOnPhone on the desktop layout: hidden the moment the phone layout is
// on, not when its cards' global outros finish (they kept the desktop's
// labels floating over the phone layout).
export function hideOnPhone(node){
    const unsub = phoneLayout.subscribe(on => node.style.display = on ? 'none' : '');
    return { destroy: unsub };
}
